import React, { useRef, Fragment, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { searchFacetChange, toggleVisibleDropdownMenu } from '../ActionsBrafab/FacetedSearch.action';
import { useStateWithCallbackLazy } from 'use-state-with-callback';

const FacetedSearchCompact = (props) => {
    const dispatch = useDispatch();
    const { visibleDropdownMenu, navigationTheme } = useSelector((state) => state.facetedSearch);
    const showLessItemCount = useRef(5);
    const list = useRef(null);
    const showLess = useRef(null);
    const showMore = useRef(null);
    const listTop = useRef(null);
    const showLessBottom = useRef(null);
    const showMoreBottom = useRef(null);
    const firstRender = useRef(true);
    const [collapsed, setCollapsed] = useStateWithCallbackLazy(false);

    const toggleHeightOnTabOpen = () => {
        setTimeout(() => {
            toggleShowMore(true);
        }, 50);
    };

    const toggleShowMore = useCallback(() => {
        setCollapsed(
            (prevState) => !prevState,
            (collapsed) => {
                list.current.height = `${
                    (collapsed ? showLessBottom.current : showMoreBottom.current) - listTop.current
                }px`;
            }
        );
    }, [setCollapsed]);

    useEffect(() => {
        // Make sure it is executed only once.
        // firstRender is used to prevent eslint warning when having empty dependencies array
        if (!firstRender.current) {
            return;
        }
        firstRender.current = false;

        const { height: listHeight, top: listPosTop } = list.current.getBoundingClientRect();

        listTop.current = listPosTop;
        showLessBottom.current = showLess.current
            ? showLess.current.getBoundingClientRect().bottom
            : null;
        showMoreBottom.current = showMore.current.getBoundingClientRect().bottom;

        const visible = listHeight !== 0;
        const tooMuchItem = props.group.options.length > showLessItemCount.current;
        visible && tooMuchItem && toggleShowMore();
    }, [toggleShowMore]);

    return (
        <Fragment>
            <ul
                className={`faceted-search__group ${
                    visibleDropdownMenu.includes(props.group.id)
                        ? 'faceted-search__group--show-compact'
                        : ''
                }`}
                ref={list}
                key={`${props.group.label}-${props.groupIndex}`}
            >
                <li
                    className={`faceted-search__group-header`}
                    role="faceted-search-item-group"
                    onClick={(event) => (
                        dispatch(toggleVisibleDropdownMenu(props.group)), toggleHeightOnTabOpen()
                    )}
                >
                    {props.group.label}
                    <span className="faceted-search__toggle-filter" key={`group-${props.group.id}`}>
                        {visibleDropdownMenu.includes(props.group.id) ? (
                            <Fragment> - </Fragment>
                        ) : (
                            <Fragment> + </Fragment>
                        )}
                    </span>
                </li>
                {props.group.options &&
                    props.group.options.map((item, itemIndex, array) => (
                        <li
                            key={`${item.label}-${itemIndex}`}
                            className="faceted-search__item"
                            role="faceted-search-item"
                            ref={
                                itemIndex === showLessItemCount - 1
                                    ? showLess
                                    : itemIndex === array.length - 1
                                    ? showMore
                                    : null
                            }
                        >
                            <FacetedFilterCheckbox
                                item={item}
                                group={props.group}
                                searchFacetChange={dispatch(searchFacetChange)}
                            />
                        </li>
                    ))}
            </ul>
            <>
                {props.group.options.length > showLessItemCount && (
                    <div className="faceted-search__show-more">
                        <span onClick={toggleShowMore}>
                            {`${
                                collapsed
                                    ? translate('filter.showmore')
                                    : translate('filter.showless')
                            }`}
                        </span>
                    </div>
                )}
            </>
        </Fragment>
    );
};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();

    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={(event) => dispatch(searchFacetChange(group, item))}
                checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)}
            />
            <span className="faceted-filter__label">
                {item.label}
                {!isNaN(item.quantity) && item.quantity != null && (
                    <span className="faceted-filter__quantity">
                        &nbsp;
                        {item.measurement != null && item.measurement.length > 0 && (
                            <Fragment>- {item.measurement} &nbsp;</Fragment>
                        )}
                        ({item.quantity}
                        {translate('common.filter.amount.short')})
                    </span>
                )}
            </span>
        </label>
    );
};

const FacetedSearchComp = ({
    facetFilters,
    query,
    searchFacetChange,
    navigationTheme,
    visibleDropdownMenu,
}) =>
    navigationTheme !== 'category' && (
        <div className="faceted-search">
            {facetFilters &&
                facetFilters.map((group, groupIndex, array) => (
                    <FacetedSearchCompact
                        key={`${group.label}-${groupIndex}`}
                        group={group}
                        searchFacetChange={searchFacetChange}
                        visibleDropdownMenu={visibleDropdownMenu}
                    />
                ))}
        </div>
    );

export default FacetedSearchComp;
